var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _require = require('../../help/runtime_support'),
    improvedDH = _require.improvedDH;

var _require2 = require('../../help/consts'),
    KEYOBJECT = _require2.KEYOBJECT;

var _require3 = require('../../jwk/generate'),
    generateSync = _require3.generateSync;

var _require4 = require('../../registry'),
    ECDH_DERIVE_LENGTHS = _require4.ECDH_DERIVE_LENGTHS;

var derive = require('./derive');

var wrapKey = function wrapKey(wrap, derive, key, payload) {
  var epk = generateSync(key.kty, key.crv);
  var derivedKey = derive(epk, key, payload);
  var result = wrap(_defineProperty({}, KEYOBJECT, derivedKey), payload);
  result.header = result.header || {};
  Object.assign(result.header, {
    epk: {
      kty: key.kty,
      crv: key.crv,
      x: epk.x,
      y: epk.y
    }
  });
  return result;
};

var unwrapKey = function unwrapKey(unwrap, derive, key, payload, header) {
  var epk = header.epk;
  var derivedKey = derive(key, epk, header);
  return unwrap(_defineProperty({}, KEYOBJECT, derivedKey), payload, header);
};

module.exports = function (JWA, JWK) {
  ['ECDH-ES+A128KW', 'ECDH-ES+A192KW', 'ECDH-ES+A256KW'].forEach(function (jwaAlg) {
    var kw = jwaAlg.substr(-6);
    var kwWrap = JWA.keyManagementEncrypt.get(kw);
    var kwUnwrap = JWA.keyManagementDecrypt.get(kw);
    var keylen = parseInt(jwaAlg.substr(9, 3), 10);
    ECDH_DERIVE_LENGTHS.set(jwaAlg, keylen);

    if (kwWrap && kwUnwrap) {
      JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, kwWrap, derive.bind(undefined, jwaAlg, keylen)));
      JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, kwUnwrap, derive.bind(undefined, jwaAlg, keylen)));

      JWK.EC.deriveKey[jwaAlg] = function (key) {
        return (key.use === 'enc' || key.use === undefined) && key.crv !== 'secp256k1';
      };

      if (improvedDH) {
        JWK.OKP.deriveKey[jwaAlg] = function (key) {
          return (key.use === 'enc' || key.use === undefined) && key.keyObject.asymmetricKeyType.startsWith('x');
        };
      }
    }
  });
};

module.exports.wrapKey = wrapKey;
module.exports.unwrapKey = unwrapKey;